import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const FooterStyle = styled.footer `
  margin: 70px auto 0;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;

  .separator {
    border-top: 0.5px solid #d1d1d1;
    padding-top: 5px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        border-top: 0.5px solid ${ColorDark.greySeparator};
      }
    }
  }
  .icon {
    display: flex;
    flex-direction: column;
    padding: 1rem 0;
    border-top: 0.5px solid ${Color.tertiaryColor};
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        border-top: 0.5px solid ${ColorDark.greySeparator};
      }
    }
    svg {
      margin-left: -1px;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding-top: 1rem;
    column-gap: 30px;

    ${breakpoints.phone} {
      flex-direction: column;
    }

    .first-group {
      display: flex;
      flex-direction: column;     
      ${breakpoints.phone} {
        width: 100%;
        flex-direction: column;
      }
      ${breakpoints.tablet} {
        width: 25%;
      }
    }

    .second-group,
    .third-group {
      display: flex;
      flex-direction: row;
      column-gap: 20px;

      ${breakpoints.tablet} {
        width: 45%;
      }
    }

    .third-group {
     
      ${breakpoints.phone} {
        margin-left: 0px;
      }
      ${breakpoints.tablet} {
        margin-left: -25px;
      }
      .digital {
        ${breakpoints.phone} {
          margin-top: -70px;
        }
      }
    }

    .list-container {
     
      ${breakpoints.phone} {
        padding-top: 1rem;
        
        flex-direction: column;
        display: flex;
      }

      &.first {
        width: 279px;
        ${breakpoints.phone} {
          flex-direction: row;
          display: flex;
          gap: 30px;
        }
      }
      &.second{
        width: 140px;
      }
      &.third{
        width: 197px;
      }
      &.fourth{
        width: 128px;
      }
      &.fifth{
        width: 178px;
      }

      &.first,&.second,&.third,&.fourth,&.fifth{
        ${breakpoints.phone} {
          width: 100%;
        }
        ${breakpoints.tablet} {
          width: 100%;
        }
      }
    }
    .list__title {
      ${Font.sansBold};
      font-size: 14px;
      color: ${Color.grey};
      margin-bottom: 1rem;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
          color:${ColorDark.textLight};
        }
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      column-gap: 0.5rem;
      padding-bottom: 1.5rem;
      padding-top: 0.2rem;

      ${breakpoints.mobileFirst} {
        flex-direction: column;
        border-bottom: none;
      }
      ${breakpoints.phone} {
        flex-direction: column;
        display: flex;
      }
      li {
        display: inline-flex;
        &:before {
          content: "•";
          margin-top: 8px;
          color: ${Color.grey};
          font-size: 8px;
          margin-right: 5px;
          ${breakpoints.phone} {
            padding-bottom: 10px;
          }
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
              color:${ColorDark.textLight};
            }
          }

        }
        a {
          ${Font.sansRegular};
          font-size: 14px;
          line-height: 22px;
          color: ${Color.grey};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
              color:${ColorDark.textLight};
            }
          }
        }
      }
      a:hover {
        color: ${Color.secondaryBlack};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
            color:${ColorDark.grey};
          }
        }
      }
    }
    .cover-footer{
      width: 248px;
      }
      ${breakpoints.phone} {
          width: 100%;
        }

        ${breakpoints.tablet} {
          width: 100%;
        }
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    gap: 10px;
    ${breakpoints.phone} {
      flex-direction: column;
    }
    ${breakpoints.tablet} {
      flex-direction: column;
      }
  }
`;